export enum FontColors {
  Gray = 'text-offWhite',
  PURPLE = 'text-[#D163E2]',
  WHITE = 'text-[#FFFFFF]',
}

export const DEFAULT_PAGE_SIZE = 10;
 